import * as React from 'react';

export const Header = (props) => (
    <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems:'center',
        margin: 50,
    }}>
        <h1 style={{ fontSize: 60, fontWeight: 300 }}>{props.children}</h1>
    </div>
);


// WEBPACK FOOTER //
// ./src/components/marketing/components/Header.js